<template>
  <div>editor type</div>
</template>

<script>
  export default {
    name: 'draft',
  }
</script>

<style scoped>

</style>